/**
 * Skincare Section JavaScript
 * Handles navigation, video controls, routine toggles, and Swiper initialization
 */

// Global variables for Swiper instances
const swiperInstances = {};

const ICON_PLAY = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M4 2.5v11l10-5.5-10-5.5z"></path></svg>';
const ICON_PAUSE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" fill="currentColor" aria-hidden="true"><rect x="3" y="2" width="4" height="12"></rect><rect x="9" y="2" width="4" height="12"></rect></svg>';

/**
 * Initialize Swiper for a specific section
 * @param {string} sectionId - The ID of the section (e.g., '36667')
 * @param {Array} slideTitles - Array of slide titles
 * @param {Array} routineIds - Array of routine IDs corresponding to slides
 */
function initSwiperForSection(sectionId, slideTitles, routineIds) {
    const swiperKey = `swiper_${sectionId}`;
    // La columna derecha ahora muestra tarjetas de packs (sin slider): solo se inicia si existe
    if (typeof Swiper === 'undefined' || !document.querySelector(`#b${sectionId} .steps`)) return;

    swiperInstances[swiperKey] = new Swiper(`#b${sectionId} .steps`, {
        fadeEffect: { crossFade: true },
        virtualTranslate: true,
        autoplay: false,
        autoHeight: true,
        speed: 1000,
        slidersPerView: 1,
        effect: "fade",
        pagination: {
            el: `#b${sectionId} .custom-bullets`,
            clickable: true,
            renderBullet: function(index, className) {
                return `<span onclick="toggleRoutine(${sectionId}, ${routineIds[index]});" class="${className}">${slideTitles[index]}</span>`;
            }
        }
    });
}

/**
 * Navigate to a specific section when clicking on main navigation
 * @param {string} id - The section ID
 */
function navigate_to(id) {
    const element = document.getElementById('b' + id);
    if (element) {
        const pos = element.getBoundingClientRect().top + window.scrollY - 75;

        // Animated scrolling
        window.scrollTo({ top: pos, behavior: 'smooth' });
    }

    // Update active state
    document.querySelectorAll('.skincare > .custom-bullets span').forEach(function (el) {
        el.classList.remove('active');
    });
    const target = document.getElementById('h' + id);
    if (target) target.classList.add('active');
}

/**
 * Toggle between different routines in a section
 * @param {string} body_id - The section ID
 * @param {string} rutina - The routine ID to show
 */
function toggleRoutine(body_id, rutina) {
    // Pause all videos in this section
    document.querySelectorAll('#b' + body_id + ' video').forEach(function (video) {
        if (!video.paused) {
            video.pause();
            // Restore play button icon
            const parent = video.parentElement;
            if (parent) {
                Array.from(parent.children).forEach(function (sibling) {
                    if (sibling !== video && sibling.classList.contains('play')) {
                        sibling.innerHTML = ICON_PLAY;
                    }
                });
            }
        }
    });

    // Show selected routine, hide others
    document.querySelectorAll('#b' + body_id + ' .video').forEach(function (el) {
        el.style.display = 'none';
    });
    document.querySelectorAll('#b' + body_id + ' .video.vid_rut_' + rutina).forEach(function (el) {
        el.style.display = 'flex';
    });
}

/**
 * Switch between video tabs within a routine
 * @param {string} body_id - The section ID
 * @param {string} nn - The video number (1, 2, etc.)
 * @param {string} rutina - The routine ID
 */
function videoTab(body_id, nn, rutina) {
    // Update video containers
    const allVideoContainers = document.querySelectorAll('#b' + body_id + ' .vid_rut_' + rutina + ' .video_container');
    const targetId = 'v' + nn + '_r' + rutina;

    allVideoContainers.forEach(function (container) {
        if (container.id === targetId) {
            container.classList.add('active');
        } else {
            container.classList.remove('active');
        }
    });

    // Update tab active states
    document.querySelectorAll('#b' + body_id + ' .vid_rut_' + rutina + ' .tab').forEach(function (el) {
        el.classList.remove('active');
    });
    const activeTab = document.querySelector('#b' + body_id + ' .vid_rut_' + rutina + ' .tab' + nn + '_rut' + rutina);
    if (activeTab) activeTab.classList.add('active');
}

/**
 * Toggle play/pause for a video
 * @param {HTMLElement} button - The play/pause button element
 * @param {string} body_id - The section ID
 * @param {string} n - The video number
 * @param {string} rutina - The routine ID
 */
function toggle_play_pause(button, body_id, n, rutina) {
    const videoContainerId = 'v' + n + '_r' + rutina;
    const videoContainer = document.getElementById(videoContainerId);

    if (!videoContainer) {
        console.warn(`Video container #${videoContainerId} not found.`);
        return;
    }

    const videoElement = videoContainer.querySelector('video');

    if (videoElement) {
        if (videoElement.paused) {
            // Play video and pause any other videos in the same routine
            pauseOtherVideos(body_id, rutina, videoContainerId);

            videoElement.play()
                .then(() => {
                    button.innerHTML = ICON_PAUSE;
                })
                .catch(error => {
                    console.error('Error playing video:', error);
                });
        } else {
            videoElement.pause();
            button.innerHTML = ICON_PLAY;
        }
    } else {
        console.warn(`No video element found inside #${videoContainerId}.`);
    }
}

/**
 * Pause all videos except the specified one
 * @param {string} body_id - The section ID
 * @param {string} rutina - The routine ID
 * @param {string} activeContainerId - The ID of the video container to keep playing
 */
function pauseOtherVideos(body_id, rutina, activeContainerId) {
    document.querySelectorAll('#b' + body_id + ' .vid_rut_' + rutina + ' .video_container video').forEach(function (video) {
        const container = video.closest('.video_container');

        if (container.id !== activeContainerId && !video.paused) {
            video.pause();
            // Update the corresponding button
            const playBtn = container.querySelector('.play');
            if (playBtn) playBtn.innerHTML = ICON_PLAY;
        }
    });
}

/**
 * Play a specific video programmatically
 * @param {string} body_id - The section ID
 * @param {string} n - The video number
 * @param {string} rutina - The routine ID
 */
function play_video(body_id, n, rutina) {
    const videoContainerId = 'v' + n + '_r' + rutina;
    const videoContainer = document.getElementById(videoContainerId);

    if (videoContainer) {
        const videoElement = videoContainer.querySelector('video');
        if (videoElement) {
            videoElement.play()
                .catch(error => console.error('Error playing video:', error));
        }
    }
}

/**
 * Handle scroll events to update active navigation state
 */
window.addEventListener('scroll', function () {
    const windowTop = window.scrollY || document.documentElement.scrollTop;

    // Update custom bullets active state based on scroll position
    document.querySelectorAll('.skincare > .custom-bullets span').forEach(function (el) {
        const id = el.getAttribute('id');
        if (id) {
            const sectionId = id.replace('h', 'b');
            const section = document.getElementById(sectionId);

            if (section) {
                const sectionTop = section.getBoundingClientRect().top + window.scrollY;

                if (windowTop >= sectionTop - 180) {
                    document.querySelectorAll('.skincare > .custom-bullets span').forEach(function (s) {
                        s.classList.remove('active');
                    });
                    el.classList.add('active');
                }
            }
        }
    });
});

/**
 * Update Swiper height on window resize
 */
window.addEventListener('resize', function () {
    // Recalculate Swiper heights for better responsiveness
    Object.keys(swiperInstances).forEach(key => {
        if (swiperInstances[key] && swiperInstances[key].update) {
            swiperInstances[key].update();
        }
    });
});

function readySkincareRoutines(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        fn();
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

/**
 * Document ready handler
 */
readySkincareRoutines(function () {
    // Adjust top position of sticky navigation
    const headerEl = document.querySelector('header');
    const headerHeight = (headerEl ? headerEl.clientHeight : 0) || 112;
    const bulletsEl = document.querySelector('.skincare > .custom-bullets');
    if (bulletsEl) bulletsEl.style.top = headerHeight + 'px';

    // Add keyboard navigation support
    document.addEventListener('keydown', function (e) {
        // Left/Right arrow keys for navigation between main sections
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            const activeBullet = document.querySelector('.skincare > .custom-bullets span.active');
            let nextBullet;

            if (activeBullet) {
                nextBullet = e.key === 'ArrowRight'
                    ? activeBullet.nextElementSibling
                    : activeBullet.previousElementSibling;
            }

            if (nextBullet) {
                const id = nextBullet.getAttribute('id');
                if (id) {
                    const sectionId = id.replace('h', '');
                    navigate_to(sectionId);
                }
            }
        }
    });

    // Initialize all Swipers
    initSwiperForSection('36667', ['RUTINA DE DÍA Y NOCHE'], ['36670']);
    initSwiperForSection('36668', ['RUTINA 1', 'RUTINA 2', 'RUTINA 3'], ['36671', '36672', '36673']);
    initSwiperForSection('36669', ['RUTINA 1', 'RUTINA 2', 'RUTINA 3'], ['36702', '36703', '36704']);
});

/**
 * Marca como activo el botón del selector de rutina (columna izquierda)
 * @param {HTMLElement} el - El botón pulsado
 */
function qwRoutineSwitch(el) {
    const parent = el.parentElement;
    if (parent) {
        Array.from(parent.children).forEach(function (sibling) {
            if (sibling !== el) sibling.classList.remove('active');
        });
    }
    el.classList.add('active');
}

// Export functions for global use
window.qwRoutineSwitch = qwRoutineSwitch;
window.navigate_to = navigate_to;
window.toggleRoutine = toggleRoutine;
window.videoTab = videoTab;
window.toggle_play_pause = toggle_play_pause;
window.play_video = play_video;
window.initSwiperForSection = initSwiperForSection;
